<template>
    <div>
        <b-modal id="modal-bulk-doc-type" no-close-on-esc centered no-close-on-backdrop hide-footer
        :body-class="'pt-3'"
        >
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('documentsBulk.docTypeTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="text-left">
                <b-form-group :label="$t('documentsBulk.docTypeLabel')">
                    <b-form-select class="input" v-model="doc_type" :options="getDotOptions">

                    </b-form-select>
                    <p v-if="errors && errors.doc_type" class="field-error">
                        {{ errors.doc_type[0] }}
                    </p>
                </b-form-group>
            </div>
            <div class="text-right modal-footer border-0 p-0 mt-3">
                <b-button class="mx-0 mr-3 h-40px w-100px" @click="resetPopup()" variant="secondary">{{ $t('documentsBulk.cancel') }}</b-button>
                <b-button class="mx-0 mb-0 h-40px w-100px mt-0" variant="primary" @click="bulkUpdateDocs">{{ $t('documentsBulk.save') }}</b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: "BulkDocType",
    props: ["modelType", "docIds"],
    computed: {
        ...mapGetters(["docTypeItems"]),
        getDotOptions() {
            return [...[{
                value: "",
                text: "",
            }], ...this.docTypeItems?.filter((item) => item.model === this.modelType || item.model === 'All').map((item) => {
                return {
                    value: item.id,
                    text: item.type,
                }
            })]
        },
    },
    data() {
        return {
            doc_type: "",
            errors: {}
        }
    },
    methods: {
        ...mapActions(['bulkUpdateDocTypeItems', "setLoader", "setNotification"]),
        resetPopup() {
            this.doc_type = ""
            this.errors = {}
            this.$bvModal.hide('modal-bulk-doc-type')
            this.$emit('close')
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async bulkUpdateDocs() {
            try {
                const nullKeys = this.checkNullValues({
                    doc_type: this.doc_type
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    await this.bulkUpdateDocTypeItems({
                        "ids": this.docIds,
                        "doc_type": this.doc_type
                    })
                    this.setLoader(false)
                    await this.setNotification({
                        msg: this.$t('documentsBulk.documentsUpdated'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.$emit("updateDocs")
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('documentsBulk.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false)
                if (typeof error === "object") {
                    this.errors = error;
                }
            }
        }

    },
}
</script>